module.exports = __webpack_public_path__ + "img/svg/weekly.ba5cffc3faaa733d622d8f35880f4cc3.svg";